import { useSelector } from 'react-redux';

import { EmployeeProfileState } from '~/data/employeeProfile/slice';
import { StoreState } from '~/reducer';
import { employeeProfileStoreStateSelector } from '~/selectors';

export const useEmployeeProfile = (): EmployeeProfileState => {
  return useSelector((state: StoreState) => {
    return employeeProfileStoreStateSelector(state).employeeProfile!;
  });
};
